import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';

import { selectActivePlanSubscription } from '../../queries/selectors/products';
import { selectAddOnSubscriptions, selectSubscriberConfig } from '../../queries/selectors/bootstrap';
import { get } from '../../utils/lodash';
import { selectClient } from '../../global-selectors';
import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { PaymentMethods } from '../../enums';
import { getSelectedPPV } from '../../queries/selectors/shoppingCart';

const withNoMembershipPurchased = (WrappedComponent) => (props) => {
  // TODO: ajustar el wrapper para que funcione con el nuevo flujo de affilates
  const Wrapper = ({
    currentSubscription,
    paymentMethod,
    push,
    subscriber,
    client,
    addOnsSubscription,
    selectedPPVToBuy,
    ...props
  }) => {
    const { location } = props;
    const ignoreRedirect = get(subscriber, 'subscription.ignoreRedirect', false);
    const isMainSubscriptioFake = currentSubscription?.purchaseState?.paymentMethod === PaymentMethods.ACCESS;

    // Incomm flows ignores subscription validation
    if (paymentMethod === 'incomm') {
      return <WrappedComponent {...props} />;
    }
    // TODO: Affiliates flows ignores subscription validation
    if (paymentMethod === 'affiliates') {
      return <Redirect to={`/${client}/subscribe/subscriptions/myaccount${location.search}`} />;
    }

    // if the subscriber bought a subscription it is redirected to myAccount
    if ((currentSubscription && !isMainSubscriptioFake && currentSubscription.productId && !ignoreRedirect)) {
      return <Redirect to={`/${client}/subscribe/subscriptions/myaccount${location.search}`} />;
    }

    return <WrappedComponent {...props} />;
  };

  Wrapper.propTypes = {
    subscriber: PropTypes.object.isRequired,
    currentSubscription: PropTypes.object.isRequired,
    client: PropTypes.string.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,
  };

  return Wrapper(props);
};

const mapStateToProps = (state) => ({
  currentSubscription: selectActivePlanSubscription(state),
  subscriber: selectSubscriberConfig(state),
  paymentMethod: selectCurrentPaymentMethod(state),
  client: selectClient(state),
  addOnsSubscription: selectAddOnSubscriptions(state),
  selectedPPVToBuy: getSelectedPPV(state),
});

const mapDispatchToProps = {
  push
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNoMembershipPurchased
);
